import React, { Component } from "react";
import { PnkConnect } from '../../../pnk-react/pnk-miniredux';

// import $ from 'jquery';
import AppUtils from '../../../apputils';
import OrganizerListPage from "./organizers-list";
import { GetOrganizersList, OrganizerDetails } from "../../../models/organizers";
import { AddOrganizer } from "../AddOrganizer";


class organizerList extends Component {
    constructor() {
        super()
        this.state = {
            OrganizerDetails: false,
            OrganizerDetailsData: {},
            getOrganizers: true,
            organizer_id: '',
            organizerlist: []
        }
    }

    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }

    GetOrganizerDetails = (id) => {

        this.setState({
            organizer_id: id,
            OrganizerDetails: true,
        })


    }
    AddOrganizer = () => {
        this.ShowAddOrganizerModal();
    }
    ShowAddOrganizerModal = () => {
        this.props.componentprops.OpenModal(AddOrganizer, 'md', { modalClass: 'profile-entry-modal', headerClass: 'profile-entry-header', titleClass: 'profile-entry-title', close: this.CloseModal, title: 'Add Organizer', action: 'Create' }, { action: 'Create', name: 'Create', Close: this.CloseModal })
    }

    ShowProfileModal = () => {
        this.props.componentprops.OpenModal(AddOrganizer, 'md', { modalClass: 'profile-entry-modal', headerClass: 'profile-entry-header', titleClass: 'profile-entry-title', title: 'Add Lead Source', action: 'Detail', data: this.state.OrganizerDetailsData, close: this.CloseModal }, { action: 'Detail', name: 'Detail', close: this.CloseModal })
    }
    CloseModal = () => {
        //   alert('jjj')
        this.setState({
            getOrganizers: true
        })
        this.props.componentprops.HandleCloseModal();

    }

    HandleGetOrganizersListSuccessResponse = (res) => {
        if (res !== false) {
            console.log(JSON.stringify(res.data.organizerslist.rows))
            this.setState({
                organizerlist: res.data.organizerslist.rows,
                getOrganizers: false

            })
        }

        else {
            this.setState({

                getOrganizers: false
            })
        }
    }

    HandleGetOrganizerDetailsSuccessResponse = (res) => {
        if (res !== false) {
            console.log(res.data.organizerdetails.rows);
            this.setState({
                OrganizerDetailsData: res.data.organizerdetails.rows,
                OrganizerDetails: false
            })
            this.ShowProfileModal();

        }
    }

    render() {
        return (
            <div>
                {localStorage.getItem('current_user_profile') !== null && localStorage.getItem('current_user_profile') === 'admin' ?
                    <OrganizerListPage {...this.props} HandleRouting={this.HandleRouting}
                        organizerlist={this.state.organizerlist} ShowProfileModal={this.ShowProfileModal}
                        GetOrganizerDetails={this.GetOrganizerDetails}
                        // ShowAddOrganizerModal={this.ShowAddOrganizerModal} 
                        AddOrganizer={this.AddOrganizer}
                    />
                    : AppUtils.HandlePageClick(this.props.componentprops, 'home')}
                {((this.state.getOrganizers === true) ? GetOrganizersList(this.props.PnkStore, this.HandleGetOrganizersListSuccessResponse) : "")}
                {((this.state.OrganizerDetails === true) ? OrganizerDetails(this.props.PnkStore, this.state.organizer_id, this.HandleGetOrganizerDetailsSuccessResponse, 'admin') : "")}
            </div>
        )
    }
}

export const OrganizerList = PnkConnect(organizerList, '');